import { css } from 'lit'

export const fileViewer = css`
  .rma-file-viewer {
    display: flex;
    align-items: center;
    gap: var(--spacing-s, 0.5rem);
    list-style: none;
  }
`
